import React from 'react'
import OneOfPlogPage from './OneOfPlogPage'
import BackGroundForPlog from './BackGroundForPlog'
import NewPlogs from './NewPlogs'

export default function ShowPlogPage() {
    return (
        <>
            <BackGroundForPlog />
            <section className='w-[95%] lg:w-[90%] 3xl:w-[80%] my-5 mx-auto lg:flex justify-center gap-10'>
                <OneOfPlogPage />
                <NewPlogs />
            </section>
        </>
    )
}
